import { render } from "./OptOutDetail.vue?vue&type=template&id=36af9f3c"
import script from "./OptOutDetail.vue?vue&type=script&lang=js"
export * from "./OptOutDetail.vue?vue&type=script&lang=js"

import "./OptOutDetail.vue?vue&type=style&index=0&id=36af9f3c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__